export default "/_next/static/images/ac1c901c8bf4f7423dd844116a3987f6.jpg";